import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiErrorResponse } from "../../../api/types/ApiErrorResponse";
import { toApiError } from "../../../api/utils/errorHandling";
import axiosInstance from "../../axiosInstance/axiosInstance";
import { AccountDeletionStatusResponse } from "../contracts/AccountDeletionStatusResponse";

export const fetchAccountDeletionStatus = createAsyncThunk<
  AccountDeletionStatusResponse,
  void,
  { rejectValue: ApiErrorResponse }
>("accountDeletion/fetchStatus", async (_, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get<AccountDeletionStatusResponse>("/account-deletion");
    return response.data;
  } catch (error) {
    return rejectWithValue(toApiError(error));
  }
});

export const scheduleAccountDeletion = createAsyncThunk<
  AccountDeletionStatusResponse,
  void,
  { rejectValue: ApiErrorResponse }
>("accountDeletion/schedule", async (_, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post<AccountDeletionStatusResponse>("/account-deletion");
    return response.data;
  } catch (error) {
    return rejectWithValue(toApiError(error));
  }
});

export const cancelAccountDeletion = createAsyncThunk<
  AccountDeletionStatusResponse,
  void,
  { rejectValue: ApiErrorResponse }
>("accountDeletion/cancel", async (_, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.delete<AccountDeletionStatusResponse>("/account-deletion");
    return response.data;
  } catch (error) {
    return rejectWithValue(toApiError(error));
  }
});

/** Downloads the full organization export as a JSON file (the before-deletion offer). */
export const downloadAccountDeletionExport = createAsyncThunk<
  void,
  void,
  { rejectValue: ApiErrorResponse }
>("accountDeletion/export", async (_, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get("/account-deletion/export", { responseType: "blob" });
    const url = URL.createObjectURL(response.data as Blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "timeplanned-export.json";
    link.click();
    URL.revokeObjectURL(url);
  } catch (error) {
    return rejectWithValue(toApiError(error));
  }
});
